import "./index.css";
import React from "react";
import { render } from "react-dom";
import { App } from "./App";
render(<App data-id="element-98" data-mp="1wal1wialzfoj" />, document.getElementById("root"));